module.exports = __webpack_public_path__ + "static/img/grandmaster.d53b4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/grandmaster.png
// module id = hHNA
// module chunks = 35